export default __webpack_public_path__ + "static/media/gallery_05.3720c332.jpg";